import { getSafeCode } from '@/apis/api';
import md5 from 'js-md5';

// 文字提示
export function toast(text, isLasting = false, duration = 3000) {
  closeLoading();
  let div = document.createElement('div');
  div.classList.add('toast-box');
  div.innerHTML = `
    <div class="toast">${text}</div>
  `;
  document.body.appendChild(div);
  if (!isLasting) {
    setTimeout(() => {
      document.body.removeChild(div);
    }, duration);
  }
}
// loading加载
export function loading() {
  closeLoading();
  let div = document.createElement('div');
  div.classList.add('toast-box');
  div.innerHTML = `
    <div class="toast">
      <div class="loading">
        <span>
          <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        </span>
      </div>
      <div>加载中...</div>
    </div>
  `;
  document.body.appendChild(div);
}
// 删除toastDom
export function closeLoading() {
  if (document.querySelector('.toast-box')) {
    document.body.removeChild(document.querySelector('.toast-box'));
  }
}

// 验证邮箱格式
export function checkMail(val) {
  const reg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/;
  if (val && reg.test(val)) return true;
}

/**
 * 格式化文件大小, 输出成带单位的字符串
 * @param {Number} size 文件大小
 * @param {Number} [pointLength = 2] 精确到的小数点数。
 * @param {Array} [units = [ 'B', 'K', 'M', 'G', 'TB' ]] 单位数组。从字节，到千字节，一直往上指定。
 *    如果单位数组里面只指定了到了K(千字节)，同时文件大小大于M, 此方法的输出将还是显示成多少K.
 */
export function formatSize(size, pointLength, units) {
  var unit;
  units = units || ['B', 'K', 'M', 'G', 'TB'];
  while ((unit = units.shift()) && size > 1024) {
    size = size / 1024;
  }
  return (
    (unit === 'B'
      ? size
      : size.toFixed(pointLength === undefined ? 2 : pointLength)) + unit
  );
}

export function setclientSessionId() {
  let sessionId = new Date().getTime();
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (var i = 0; i < 10; i++) {
    sessionId += characters.charAt(
      Math.floor(Math.random() * charactersLength)
    );
  }
  sessionStorage.setItem('sessionId', sessionId);
  return sessionId;
}
export function setBrowserUrl(resource) {
  // stringify是queryString的一个api，具体可以查看node官网，也可以自己实现
  var url = `${location.pathname}?id=${resource}`;
  history.pushState({ url: url }, '', url);
}

// 禁止微信字体缩放
export function disabledScale() {
  if (window.WeixinJSBridge) {
    // https://manage.xinjiaoyu.com/api/v2/sch_mgmt_server/schools/1c88b125c8b75eb4fbd46aa64b0b3aa5/phaseGradeCourse
    if (
      typeof WeixinJSBridge == 'object' &&
      typeof WeixinJSBridge.invoke == 'function'
    ) {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', handleFontSize);
        document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
      }
    }
  }
}
function handleFontSize() {
  WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  WeixinJSBridge.on('menu:setfont', function() {
    WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
  });
}
